import { render, staticRenderFns } from "./OrientationPicker.vue?vue&type=template&id=2639b02f"
import script from "./OrientationPicker.vue?vue&type=script&lang=ts"
export * from "./OrientationPicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports